export default {"src":"/_next/static/media/ic-video.94193e27.svg","height":34,"width":44,"blurWidth":0,"blurHeight":0};